import React, { FC } from 'react';
import {
  DigitalingOverall,
  DigitalingOverallRankingTable,
} from '@purchase/supplier';

export interface DigitalingSectionProps {
  vendorId: string;
}

export const DigitalingSection: FC<DigitalingSectionProps> = ({ vendorId }) => {
  return (
    <>
      <DigitalingOverall vendorId={vendorId} />
      <DigitalingOverallRankingTable vendorId={vendorId} className="mt-[12px]" />
    </>
  );
};
